import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiConnectorService } from '../../../___LOGIC/__api/api-connector.service';
import { DynamicCrudService } from 'src/app/___LOGIC/__crud/dynamic-crud.service';

@Component({
  selector: 'app-dynamic-crud-select',
  templateUrl: './dynamic-crud-select.component.html',
  styleUrls: ['./dynamic-crud-select.component.css']
})
export class DynamicCrudSelectComponent implements OnInit {

  @Input() data;
  @Input() status;
  @Output() public dataOut = new EventEmitter();
  editMode = false;
  foreignKeyOptions = [];
  selectOptionValue = '';
  selectedOption;
  selectedObj;

  constructor(private dynamicCrudService: DynamicCrudService,private apiConnector: ApiConnectorService) { }

  ngOnInit(): void {
    this.getComboboxOptions();
  }

  getComboboxOptions(){
    debugger
      this.apiConnector.simpleQueryId('get', this.getTableName(this.data.fieldName),null,null,null,null)
      .subscribe(response => this.saveDataToLocalClass(response));
  }

  saveDataToLocalClass(response){
    this.foreignKeyOptions = response.records;
    this.selectOptionValue = response.props[1].columnName;
  }

  isEditMode(){
    return this.editMode && this.dynamicCrudService.isCurrentFieldEditing(this.data.columnName);
  }

  switchEditingMode(){
    this.editMode = !this.editMode;
    this.editMode? this.dynamicCrudService.setCurrentFieldToEdit(this.data.columnName): null;
  }

  updateSelection(selectedObj){
    this.selectedObj = selectedObj;
    this.data.value =  selectedObj.id;
    this.dataOut.emit(this.data);
    this.switchEditingMode();
  }

  getTableName(columnName){
    return columnName.substring(6);
  }

  getSelectedValue(){
    if(this.dynamicCrudService.getCurrentStatus() == 'update'){
      if(this.foreignKeyOptions.length>0){
        return this.foreignKeyOptions[this.data.value][this.selectOptionValue];
      }else{
        return '';
      }
    }else{
      return this.selectedObj[this.selectOptionValue];
    }
  }

}
